import React, { useEffect, useState } from "react";
import "./varniSelectDonationAmount.css"
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { RenderAmount } from "../../components/renderAmount";
import { RootState, useAppDispatch } from "../../state/store";
import { clearDonationAmount, DonationState, resetDonorInfo, setDonationAmount } from "../../state/donation";
import { Navigate, useNavigate } from "react-router-dom";
import { CheckoutState, resetCheckoutState } from "../../state/checkout";
import { useSelector } from "react-redux";
import { AuthInfo, AuthState } from "../../state/auth";
import { RenderVarniAmount } from "../../components/renderVarniAmount";

export function VarniSelectDonationAmount() {

    const [selectedAmount, setSelectedAmount] = useState<number>(0);
    const appDispatch = useAppDispatch();
    const navigate = useNavigate();
    const donationInfo = useSelector<RootState, DonationState>(state => state.DonationInfo);
    const loginState = useSelector<RootState, AuthState>(state => state.AuthInfo);

    useEffect(() => {
        appDispatch(resetDonorInfo());
        appDispatch(clearDonationAmount())
        appDispatch(resetCheckoutState());
    }, []);

    const onDonationAmountSelected = (amount: number) => {
        setSelectedAmount(amount);
        appDispatch(setDonationAmount(amount));
        navigate("/varni-confirm-receipt-needed");
        setTimeout(() => {

        }, 1000);
    }

    const onPayClicked = () => {
        appDispatch(setDonationAmount(selectedAmount));
        navigate("/varni-pay");
    }

    const renderPayButton = () => {
        return selectedAmount > 0 ?
            (<Button variant="outlined" size="lg" onClick={onPayClicked} style={{ backgroundColor: "#ffffff", color: "#7F499D" }}>
                Pay <span style={{ fontWeight: "bold" }}>${selectedAmount}</span>  Using Card (Note: No Receipt will be issued)
            </Button>) :
            (<React.Fragment />);
    }

    return (<div className="varni-select-donation-amount">
        <Row style={{ padding: "30px", margin: "0" }}>
            <Col md={8} sm={8} lg={8}>
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <div style={{textAlign: "center"}}>
                        <img src="/Text1.png" style={{ width: "60%" }} />
                    </div>
                    <div className="bubble-row">
                        <RenderVarniAmount value={5} onClicked={onDonationAmountSelected} selected={selectedAmount === 5} />
                        <RenderVarniAmount value={51} onClicked={onDonationAmountSelected} selected={selectedAmount === 51} />
                    </div>
                    <div className="bubble-row">
                        <RenderVarniAmount value={111} onClicked={onDonationAmountSelected} selected={selectedAmount === 111} />
                        <RenderVarniAmount value={251} onClicked={onDonationAmountSelected} selected={selectedAmount === 251} />
                    </div>
                    <div className="bubble-row">
                        <RenderVarniAmount value={1751} onClicked={onDonationAmountSelected} selected={selectedAmount === 1751} />
                    </div>
                </div>
            </Col>
            <Col md={4} sm={4} lg={4}>
                <img src="/MSM.png" style={{ height: "90vh" }} />
            </Col>
        </Row></div>)
}